import _ from 'lodash';
/** import third-party libraries in the section above, Sort Lines Ascending */

import {
    filterRecordsByKeywords,
    sortRecordsByName,
} from 'states/resources/organizations/business-logic';
/** import multi application imports in the section above, Sort Lines Ascending */

import { PermissionsMapping } from 'common/constants/role-intents';
import { can } from 'services/can';
import { createHttp } from 'utils/http';
/** import single application imports in the section above, Sort Lines Ascending */

const actions = {
    /**
     * Fetch the authenticated user's organization; nested users only when admin_user__view.
     */
    fetchOwnOrganizationData: () => {
        return async (dispatch, getState) => {
            try {
                dispatch({
                    type: 'ADMIN_V2__FETCH_OWN_ORGANIZATION_START',
                    payload: {},
                });

                // admin_user__view — gates nested users in GraphQL (urban GET /users)
                const includeUsers = can(PermissionsMapping.ADMIN_USER__VIEW);
                const http = createHttp();
                const query = `
                    query getOwnOrganizationData${
                        includeUsers ? ' ($userFilters: UserFilters)' : ''
                    } {
                        ownOrganization {
                            id
                            name
                            type
                            default_timezone
                            revenueModel
                            currency
                            tech_fee
                            agencyMarginRate
                            ${
                                includeUsers
                                    ? `users(filters: $userFilters) {
                                id
                                name
                                email
                                global_role
                            }`
                                    : ''
                            }
                            privateInventorySpendTiers {
                                techFee
                                min
                                max
                            }
                            publicInventorySpendTiers {
                                techFee
                                min
                                max
                            }
                            latestTierCalculation {
                                calculatedAt
                                dateRange {
                                    start
                                    end
                                }
                                cpmBasedSpend
                                currency
                                publicInventoryTechFee
                                privateInventoryTechFee
                                timezone
                            }
                        }
                    }
                `;

                const variables = includeUsers
                    ? {
                          userFilters: {
                              deprecated: false,
                          },
                      }
                    : {};

                const { ownOrganization: organization } = await http.graphql(query, variables);
                const sortedUsers = sortRecordsByName(organization.users, {
                    nameField: 'name',
                });

                dispatch({
                    type: 'ADMIN_V2__FETCH_OWN_ORGANIZATION_END',
                    payload: {
                        data: { organization, users: sortedUsers },
                    },
                });
            } catch (err) {
                if (window.bugsnagClient) {
                    window.bugsnagClient.notify(
                        `Failed to fetch organization user data in admin page`,
                        {
                            metaData: {
                                organizationId: _.get(getState(), 'profile.organizationId'),
                            },
                        }
                    );
                }
            }
        };
    },

    /**
     * Filters own-organization users by name, id, or email (@ substring or exact local/domain).
     * @param {string} keywords - Search text
     */
    filterUsers: keywords => {
        return (dispatch, getState) => {
            dispatch({
                type: 'ADMIN_V2__FILTER_USERS_START',
                payload: {},
            });
            const users = _.get(getState(), 'adminV2.ownOrganization.organization.users', []);
            // @ substring or exact local/domain email match (case-insensitive)
            const filteredUsers = filterRecordsByKeywords(users, keywords, {
                nameField: 'name',
                idField: 'id',
                emailField: 'email',
            });
            dispatch({
                type: 'ADMIN_V2__FILTER_USERS_END',
                payload: { filteredUsers },
            });
        };
    },
};

export default actions;
